import React, { useState } from 'react';

// Utils
import { useTranslation } from 'next-i18next';
import { useModal } from '../../../src/store/ModalContext';
import useReplaceCartFromUrl from '../../../src/hooks/useReplaceCartFromUrl';

// Components
import Modal from '../../organisms/Modal/Modal';
import Button from '../../atoms/Button/Button';

import styles from './ReplaceCartModal.module.css';

function ReplaceCartModal() {
  const { t } = useTranslation();
  const { isModalOpen, closeModal } = useModal();
  const { handleKeepOngoingCart, handleReplaceCartConfirm } = useReplaceCartFromUrl();

  const [isResetLoading, setIsResetLoading] = useState(false);

  return (
    <Modal
      id="modal-replace-cart"
      title={t('search.reset.title')}
      isOpen={isModalOpen('modal-replace-cart')}
      onClose={() => closeModal('modal-replace-cart')}
    >
      <p className={`${styles['modal-content']} m-t-20 fw-400`}>
        {t('search.reset.text')}
      </p>
      <div className="flex a-center j-spb m-t-30 mobile-d-col">
        <Button
          onClick={handleKeepOngoingCart}
          classNames="flex-auto m-r-20 mobile-w-100 mobile-m-r-0 mobile-m-b-10"
          text="uppercase"
          color="inverted-secondary"
        >
          {t('search.reset.no')}
        </Button>
        <Button
          onClick={() => handleReplaceCartConfirm(setIsResetLoading)}
          classNames="flex-auto mobile-w-100"
          text="uppercase"
          isLoading={isResetLoading}
          disabled={isResetLoading}
        >
          {t('search.reset.yes')}
        </Button>
      </div>
    </Modal>
  );
}

ReplaceCartModal.propTypes = {};

export default ReplaceCartModal;
